import { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default function LeafletMap({ area }) {
  const [map, setMap] = useState(null);
  const [locationName, setLocationName] = useState(area || "Mumbai");

  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  const [marker, setMarker] = useState(null);

  // Geocoding: Location name to coordinates
  const getCoordinates = async (locationName) => {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?q=${locationName}&format=json`
    );
    const data = await response.json();
    if (data.length > 0) {
      return {
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
        name: data[0].display_name,
      };
    }
  };

  // Reverse geocoding: Coordinates to location name
  const getLocationNameFromCoords = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      );
      const data = await response.json();
      const name = data.address.name || data.display_name;

      setCoordinates({ lat: parseFloat(lat), lng: parseFloat(lng) });
      setLocationName(name);

      if (marker) marker.remove();
      const newMarker = L.marker([lat, lng]).addTo(map).bindPopup(name);

      setMarker(newMarker);
    } catch (error) {
      console.error("Error getting location name:", error);
    }
  };

  // Search location by name
  const searchLocation = async (locationName) => {
    try {
      const result = await getCoordinates(locationName);
      if (result) {
        setCoordinates({
          lat: parseFloat(result.lat),
          lng: parseFloat(result.lng),
        });
        setLocationName(result.name);
        map.setView([result.lat, result.lng], 13);

        if (marker) marker.remove();
        const newMarker = L.marker([result.lat, result.lng])
          .addTo(map)
          .bindPopup(result.name);

        setMarker(newMarker);
      }
    } catch (error) {
      console.error("Error searching location:", error);
    }
  };

  useEffect(() => {
    const mapInstance = L.map("map").setView([19.076, 72.8777], 13);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(mapInstance);

    const initialMarker = L.marker([19.076, 72.8777])
      .addTo(mapInstance)
      .bindPopup("Mumbai")
      .openPopup();

    setMap(mapInstance);
    setMarker(initialMarker);

    // Click on map to get location name
    mapInstance.on("click", (e) => {
      getLocationNameFromCoords(e.latlng.lat, e.latlng.lng);
    });

    return () => {
      mapInstance.remove();
    };
  }, []);

  // Search for location when area prop changes
  useEffect(() => {
    if (area && map && area !== "Mumbai") {
      searchLocation(area);
    }
  }, [area, map]);

  return (
    <div>
      <div id="map" style={{ height: "400px", width: "100%" }}></div>
      {/* <div
        style={{
          marginTop: "10px",
          padding: "10px",
          backgroundColor: "#f5f5f5",
          borderRadius: "4px",
        }}
      >
        <p>
          <strong>Location:</strong> {locationName}
        </p>
        <p>
          <strong>Coordinates:</strong> Lat:{" "}
          {coordinates.lat?.toFixed(4) || "N/A"}, Lng:{" "}
          {coordinates.lng?.toFixed(4) || "N/A"}
        </p>
      </div> */}
    </div>
  );
}
